import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// 导入翻译文件
import ar from '../../messages/ar.json'
import bn from '../../messages/bn.json'
import en from '../../messages/en.json'
import fa from '../../messages/fa.json'
import id from '../../messages/id.json'
import pt from '../../messages/pt.json'
import ru from '../../messages/ru.json'
import tr from '../../messages/tr.json'
import ur from '../../messages/ur.json'
import uz from '../../messages/uz.json'
import zh from '../../messages/zh.json'

// 支持的语言列表
export const locales = ['ar', 'bn', 'en', 'fa', 'id', 'pt', 'ru', 'tr', 'ur', 'uz', 'zh'] as const
export type Locale = (typeof locales)[number]

// 默认语言
export const defaultLocale: Locale = 'en'

// 语言名称映射
export const localeNames: Record<Locale, string> = {
  ar: 'العربية', // 阿拉伯语
  bn: 'বাংলা', // 孟加拉语
  en: 'English', // 英语
  fa: 'فارسی', // 波斯语
  id: 'Bahasa Indonesia', // 印尼语
  pt: 'Português', // 葡萄牙语
  ru: 'Русский', // 俄语
  tr: 'Türkçe', // 土耳其语
  ur: 'اردو', // 乌尔都语
  uz: "O'zbek", // 乌兹别克语
  zh: '中文', // 中文
}

// RTL 语言列表
export const rtlLanguages: Locale[] = ['ar', 'fa', 'ur']

// 判断是否为 RTL 语言
export const isRTL = (locale: string): boolean => {
  return rtlLanguages.includes(locale as Locale)
}

// 获取文本方向
export const getDirection = (locale: string): 'rtl' | 'ltr' => {
  return isRTL(locale) ? 'rtl' : 'ltr'
}

// 判断当前的语言是不是 rtlLanguages
export const isRTLMode = (): boolean => {
  // 获取当前 i18n 的语言并判断是否为 RTL
  const currentLanguage = i18n.language || defaultLocale
  return isRTL(currentLanguage)
}

// 初始化 i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ar: { translation: ar },
      bn: { translation: bn },
      en: { translation: en },
      fa: { translation: fa },
      id: { translation: id },
      pt: { translation: pt },
      ru: { translation: ru },
      tr: { translation: tr },
      ur: { translation: ur },
      uz: { translation: uz },
      zh: { translation: zh },
    },
    fallbackLng: defaultLocale,
    supportedLngs: [...locales],

    // 语言检测配置
    detection: {
      // 检测顺序：URL路径 > localStorage > 浏览器设置
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React 已经安全处理了 XSS
    },

    react: {
      useSuspense: false,
    },
  })

export default i18n
